import * as Yup from 'yup';
import ProfileRole from '../entities/profile-role';

export interface ProfileForm {
  role: ProfileRole;
  condominiumId?: string | null;
  sectionId?: string | null;
  unitId?: string | null;
}

export type ProfileFormShape = {
  [key in keyof ProfileForm]?: any;
};

export const schema = Yup.object().shape<ProfileFormShape>({
  role: Yup.mixed().required('Selecione a função'),
  sectionId: Yup.mixed().test('validateCondominium', 'Selecione um bloco', (data, context) => {
    const isManager = (context.parent as ProfileForm).role === ProfileRole.Manager;
    const isEmployee = (context.parent as ProfileForm).role === ProfileRole.Employee;
    const hasSelectedUnit = (context.parent as ProfileForm).unitId != null;

    if (isManager || isEmployee || hasSelectedUnit) return true;

    return Boolean(data && data.length > 0);
  }),
  condominiumId: Yup.mixed().test('validateCondominium', 'Selecione um condomínio', (data, context) => {
    const isManager = (context.parent as ProfileForm).role === ProfileRole.Manager;

    if (isManager) return true;

    return Boolean(data && data.length > 0);
  }),
  unitId: Yup.mixed().test('validateUnit', 'Selecione a unidade', (data, context) => {
    const isManager = (context.parent as ProfileForm).role === ProfileRole.Manager;
    const isEmployee = (context.parent as ProfileForm).role === ProfileRole.Employee;

    if (isManager || isEmployee) return true;

    return Boolean(data && data.length > 0);
  }),
});
